import { processRequest } from '../../../services/Api';
import { put, call, takeLatest, all } from 'redux-saga/effects';
import { parentRequestModalActionTypes } from './Constants';
import * as parentRequestModalActions from './Actions';
import * as notificationActions from '../../notification/Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';
import i18n from 'i18next';

export default function* () {
	yield all([
		yield takeLatest(
			parentRequestModalActionTypes.GET_AVAILABLE_PACKAGES_REQUEST,
			handleGetAvailablePackagesRequest,
		),
		yield takeLatest(
			parentRequestModalActionTypes.PARENT_PAYMENT_REQUEST,
			handleParentPaymentRequest,
		),
		yield takeLatest(
			parentRequestModalActionTypes.WHATSAPP_SHARE_REQUEST,
			handleWhatsAppShareRequest,
		),
	]);
}

export function* handleGetAvailablePackagesRequest() {
	try {
		const { data } = yield call(processRequest, 'public/packages');

		yield put(parentRequestModalActions.getAvailablePackagesSuccess(data.packages));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(parentRequestModalActions.toggleParentRequestModal(false));
		yield put(parentRequestModalActions.getAvailablePackagesError());
	}
}

export function* handleParentPaymentRequest(action) {
	try {
		const requestPayload = {
			payment_request: action.payload.modalData,
		};
		yield call(processRequest, 'payment_requests', 'POST', requestPayload);

		yield put(parentRequestModalActions.parentPaymentSuccess());
		yield put(parentRequestModalActions.toggleParentRequestModal(false));
		yield put(
			notificationActions.createNotification(
				i18n.t('modals.parent_request.request_notification'),
			),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(parentRequestModalActions.parentPaymentError());
	}
}

export function* handleWhatsAppShareRequest({ payload }) {
	try {
		const requestPayload = {
			plan_id: payload.planId,
		};

		const { data } = yield call(
			processRequest,
			'payment_requests/whatsapp_sharing',
			'GET',
			requestPayload,
		);

		window.open(data?.url, '_system');
		yield put(parentRequestModalActions.toggleParentRequestModal(false));
		yield put(
			notificationActions.createNotification(
				i18n.t('modals.parent_request.request_notification'),
				null,
				false,
				8000,
			),
		);
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(parentRequestModalActions.whatsAppShareError());
	}
}
